import { useAmazonConnectReady } from './AmazonConnectCCP';
import { AmazonConnectControls } from './AmazonConnectControls';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Paper, CircularProgress } from '@gapartners/ui';

export function AmazonConnectPanel() {
  const { isReady, error } = useAmazonConnectReady();
  const { t } = useTranslation();

  const loadingState = !isReady && !error;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      {loadingState && (
        <Box
          sx={{
            position: 'fixed',
            inset: 0,
            bgcolor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 50,
          }}
        >
          <Paper
            sx={{
              p: 4,
              maxWidth: '28rem',
              width: '100%',
              mx: 2,
              borderRadius: 2,
              boxShadow: 3,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 2,
              }}
            >
              <CircularProgress size={48} />
              <Typography fontWeight={500} color="text.primary" align="center">
                {t('components.amazonConnect.initializingAmazonConnect')}
              </Typography>
              <Typography variant="body2" color="text.secondary" align="center">
                {t('components.amazonConnect.pleaseCompleteLogin')}
              </Typography>
            </Box>
          </Paper>
        </Box>
      )}
      {error && isReady && (
        <Paper variant="outlined" sx={{ p: 3 }}>
          <Box
            sx={{
              bgcolor: '#fef2f2', // red-50
              border: '1px solid',
              borderColor: 'error.light',
              color: 'error.dark',
              px: 2,
              py: 1.5,
              borderRadius: 1,
            }}
          >
            <Typography fontWeight={600}>{t('common.error')}</Typography>
            <Typography variant="body2" sx={{ mt: 0.5 }}>
              {error}
            </Typography>
          </Box>
        </Paper>
      )}
      {isReady && !error && (
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', lg: '1fr 1fr' },
            gap: 3,
          }}
        >
          <Box>
            <AmazonConnectControls />
          </Box>
        </Box>
      )}
    </Box>
  );
}
